import React from 'react';

import { Box, Card, CardContent, Grid, Link, Typography } from '@mui/material';

import { COLOR_GREY_800, COLOR_PRIMARY_1 } from 'src/colors';
import { COLOR_TOOLTIP_BACKGROUND } from 'src/const';

const MainKPITooltip = ({ tooltipConfig, matches }) => {
  return (
    <Card sx={{ maxWidth: matches ? '80vw' : 400, p: 0 }}>
      <CardContent sx={{ backgroundColor: COLOR_TOOLTIP_BACKGROUND, p: 2 }}>
        <Grid container spacing={1} direction="column">
          {/* Definition */}
          <Grid item>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {tooltipConfig.description.length > 0 &&
                tooltipConfig.description.map((line, index) => (
                  <Typography key={index} variant="body2" sx={{ fontWeight: 500 }}>
                    {line}
                  </Typography>
                ))}
            </Box>
          </Grid>

          {/* Calculation Section */}
          {tooltipConfig.calculation && (
            <Grid item>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ fontWeight: 'bold', borderBottom: `1px solid ${COLOR_GREY_800}`, pb: 0.5 }}
              >
                Calculation:
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {tooltipConfig.calculation.length > 0 &&
                  tooltipConfig.calculation.map((line, index) =>
                    tooltipConfig.calculation.length > 1 ? (
                      <Box key={index} component="li">
                        {line}
                      </Box>
                    ) : (
                      <Box key={index}>{line}</Box>
                    )
                  )}
              </Typography>
            </Grid>
          )}

          {/* Calculation Reference */}

          <Grid item>
            {tooltipConfig.calcRef &&
              tooltipConfig.calcRef.length > 0 &&
              tooltipConfig.calcRef.map((line, index) => (
                <Box sx={{ borderLeft: `2px solid ${COLOR_GREY_800}`, pl: 1 }} component="li">
                  <Typography variant="caption" sx={{ fontWeight: 500 }}>
                    {line}
                  </Typography>
                </Box>
              ))}
          </Grid>

          {/* CTA URL */}
          {tooltipConfig.ctaUrl && (
            <Grid item>
              <Link href={tooltipConfig.ctaUrl} target="_blank" rel="noreferrer">
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: COLOR_PRIMARY_1 }}>
                  Learn More
                </Typography>
              </Link>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MainKPITooltip;
